import styles from "./CohortTimeframe.module.scss";
import {Col, InputNumber} from "antd";
import React from "react";
import {MAX_MONTHS, periodMonthsSet} from "./utils";
import {CircleIcon} from "./CircleIcon";
import ToolTip, { LOOKBACK_PERIOD } from "../common/ToolTip";

export type LookBackPeriodInputProps = {
    readOnly: boolean
    queryId: number
    lookBackMonths: number
    setLookBackMonths: (queryId: number, value: number | string | undefined) => void
    testId: string
}

export type LookBackPeriodProps = {
    lookBackMonths: number
}


export const LookBackPeriodInput = ({readOnly, queryId, lookBackMonths, setLookBackMonths, testId}: LookBackPeriodInputProps) => {
    if (readOnly && lookBackMonths < 1) {
        return null;
    }

    return <div className={styles.lookBackPeriodUpperContainer} data-testid={testId}>
        <div>
            {!periodMonthsSet(lookBackMonths) ?
                <><span className={styles.lookBackHighlight}>Look-Back Period<ToolTip content={LOOKBACK_PERIOD}/></span><br/></>
                : ''
            }
            <span>Months</span><br/>
            <span>
            <InputNumber
                readOnly={readOnly}
                className={styles.periodInput}
                min={1} max={MAX_MONTHS}
                value={lookBackMonths}
                onChange={(value) => setLookBackMonths(queryId, value)}
            />
        </span>
        </div>
    </div>
}

export const LookBackPeriod = ({lookBackMonths}: LookBackPeriodProps) => {
    if (!periodMonthsSet(lookBackMonths)) {
        return <></>
    }

    return <Col flex={lookBackMonths}>
        <div className={styles.lookBackPeriodUpper}>
            <CircleIcon radius={3} className={styles.lookBackPeriodStartCircle}/>
        </div>
        <div className={styles.lookBackPeriodLower}>
            <span className={styles.lookBackHighlight}>Look-Back Period<ToolTip content={LOOKBACK_PERIOD}/></span><br/>
        </div>
    </Col>
}